import './App.css';

import UilReact from "@iconscout/react-unicons/icons/uil-react"
import TopButtons from './components/TopButtons';
import Inputs from './components/Inputs';
import TimeAndLocation from './components/TimeAndLocation';
import TemperatureAndDetails from './components/TemperatureAndDetails';
import Forecast from './components/Forecast';
import getFormattedweatherData from './services/weatherAPI'
import { useEffect, useState } from 'react';


function App() {
  const [query, setQuery] = useState({q:'Cianjur',units:'metric'})
  const [weather, setWeather] = useState(null)

  useEffect( () => {
    const fetchWeather = async () => {
      await getFormattedweatherData({...query})
        .then(data => setWeather(data))
    }
    fetchWeather()

  },[query])

  const background = () => {
    if(weather){
      if(weather.temp > 20 ) return 'from-orange-400 to-red-600'
      return 'from-cyan-400 to-blue-600'
    }
  }

  return (
  
    <div className={` py-5 lg:px-32 bg-gradient-to-tr ${background()} h-screen shadow-xl `}>
      <TopButtons setQuery={setQuery} />
      <Inputs setQuery={setQuery} />

      {
        weather && (
          <div>
            <TimeAndLocation weather={weather}/>
            <TemperatureAndDetails weather={weather}/>

          </div>
        )
      }
      <div className='text-xs text-center text-white text-opacity-70'>
            Created by Soffie Anastya Putri
      </div>

    </div>
  
  );
}

export default App;
